import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import { safeStorage } from '@/lib/storage'

export const USAGE_DATA_STORAGE_KEY = 'leazepro.usageData'

interface UsageDataState {
  /** Settings → "Share usage data" (LP-947). On by default; off stops GA4 and our own events. */
  share: boolean
  setShare: (share: boolean) => void
}

/** Kept per browser, so it survives a reload and a sign-out (same as the theme). */
export const useUsageDataStore = create<UsageDataState>()(
  persist((set) => ({ share: true, setShare: (share) => set({ share }) }), { name: USAGE_DATA_STORAGE_KEY, storage: createJSONStorage(() => safeStorage) }),
)
